module.exports = __webpack_public_path__ + "img/pro_three_1.8dc07671.jpg";